import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;
let section = "";
let pingNow = null;

/** Tell Live Users which section of the current page this person is looking at. */
export const setPresenceSection = (s) => {
  const next = s || "";
  if (next === section) return;
  section = next;
  pingNow?.();
};

export const tokenFor = (path) => {
  if (sessionStorage.getItem("nex_preview_token")) return null;  // a super admin's read-only preview never counts as that person being online
  if (path.startsWith("/vendor")) return localStorage.getItem("tea_vendor_token");
  if (path.startsWith("/portal/resident")) return localStorage.getItem("tea_resident_token") || new URLSearchParams(window.location.search).get("token");
  return localStorage.getItem("nex_token");
};

/** Heartbeat for the super admin's Live Users view — every 20s, on page change and on section change. */
export function PresencePinger() {
  const { pathname } = useLocation();
  useEffect(() => {
    const ping = () => {
      const t = tokenFor(window.location.pathname);
      if (!t || document.hidden) return;
      axios.post(`${ROOT}/presence/ping`, { page: window.location.pathname, section }, { headers: { Authorization: `Bearer ${t}` } }).catch(() => {});
    };
    pingNow = ping;
    ping();
    const id = setInterval(ping, 20000);
    document.addEventListener("visibilitychange", ping);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", ping); };
  }, [pathname]);
  return null;
}
